import "./Cart.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import TerminalFooter from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <TrendMitraNavigationHeader />
      <CartContent />
      <TerminalFooter />
    </div>;
}